import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SharedErrors } from 'web_core_library';

export interface IAppState {
  loading: boolean;
  ready: boolean;
  focused: boolean;
}

export const initialState: IAppState = {
  loading: false,
  ready: false,
  focused: true,
};

export const statePropName = 'app';

const appSlice = createSlice({
  name: statePropName,
  initialState,
  reducers: {
    appStart(state) {
      return {
        ...initialState,
        loading: true,
        // languageLoading: true,
      };
    },
    appStarted(state, action: PayloadAction<boolean>) {
      state.loading = false;
      state.ready = true;
      state.focused = action.payload;
    },
    appStartFailed: {
      reducer: <T extends SharedErrors.BaseError>(state, action: PayloadAction<T>) => {
        state.loading = false;
        state.ready = false;
      },
      prepare: <T extends SharedErrors.BaseError>(error: T) => ({
        payload: error,
      }),
    },
  },
});

export const AppActions = appSlice.actions;
export default appSlice.reducer;
